/** @format */
import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DocStat.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const LotStat = ({ lots }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { t } = useTranslation();

  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  const statusCounts = lots.reduce((acc, lot) => {
    const status = lot.sStatus;
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  
  const chartData = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        label: t("Nombre de lots"),
        data: Object.values(statusCounts),
        backgroundColor: [
          "rgba(255, 99, 132, 0.7)",
          "rgba(54, 162, 235, 0.7)",
          "rgba(255, 206, 86, 0.7)",
          "rgba(75, 192, 192, 0.7)",
          "rgba(153, 102, 255, 0.7)",
          "rgba(255, 159, 64, 0.7)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y", 
    responsive: true,
    plugins: {
      legend: { position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: { beginAtZero: true, ticks: { stepSize: 1 } },
    },
  };

  
  const stats = lots.reduce(
    (acc, lot) => {
      const { iCreatedDocs = 0, iCompletedDocs = 0 } = lot;
      acc.totalDocuments += iCreatedDocs;
      acc.realisesDocuments += iCompletedDocs;
      if (lot.sStatus === "completed") acc.realisesLots += 1;
      return acc;
    },
    { totalDocuments: 0, realisesDocuments: 0, realisesLots: 0 }
  );

  return (
    <div className="div_stats">
      <div className="div_stats_menu d-flex ">
        <div className="div_stats_menu_fleche" onClick={toggleCollapse}>
          <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
        </div>
        <p
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            paddingTop: "10px",
            marginLeft: "8px",
          }}
        >
          {t("Statistics")}
        </p>
      </div>

      {!isCollapsed && (
        <div
          className="cadres_stats"
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            marginTop: "15px",
          }}
        >
          
          <div
            className="chart-card"
            style={{
              flex: "0 0 40%", 
              minWidth: "300px",
              padding: "15px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              background: "#fff",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>

          {/* Cards à côté */}
          <div
            className="cards-wrapper"
            style={{
              flex: "1",
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)", 
              gridTemplateRows: "repeat(2, 1fr)", 
              gap: "12px",
              alignContent: "start",
            }}
          >
            {[
              {
                label: `${t("Total")} ${t("Lots")}`,
                value: lots.length,
                border: "#3498db",
              },
              {
                label: `${t("Total")} ${t("Documents")}`,
                value: stats.totalDocuments,
                border: "#185d8b",
              },
              {
                label: `${t("Lots")} ${t("In progress")}`,
                value: lots.length - stats.realisesLots,
                border: "#2ecc71",
              },
              {
                label: `${t("Documents")} ${t("In progress")}`,
                value: stats.totalDocuments - stats.realisesDocuments,
                border: "#229652",
              },
              {
                label: `${t("Lots")} ${t("Completed")}`,
                value: stats.realisesLots,
                border: "#805d93",
              },
              {
                label: `${t("Lots")}  ${t("Completed")} %`,
                value:
                  lots.length > 0
                    ? ((stats.realisesLots / lots.length) * 100).toFixed(1) +
                      "%"
                    : "0%",
                border: "#34495e",
              },
              {
                label: `${t("Documents")} ${t("Completed")}`,
                value: stats.realisesDocuments,
                border: "#eaaa22",
              },
              {
                label: `${t("Documents")}  ${t("Completed")} %`,
                value:
                  stats.totalDocuments > 0
                    ? (
                        (stats.realisesDocuments / stats.totalDocuments) *
                        100
                      ).toFixed(1) + "%"
                    : "0%",
                border: "#ea7d25",
              },
            ].map((counter, i) => (
              <div
                key={i}
                className="counter-card"
                style={{
                  background: "#fff",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "90px", 
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(0,0,0,0.1)";
                  e.currentTarget.style.border = `1px solid ${counter.border}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(0,0,0,0.08)";
                  e.currentTarget.style.border = "1px solid #e0e0e0";
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    color: "#666",
                    textTransform: "uppercase",
                  }}
                >
                  {counter.label}
                </p>
                <h3
                  style={{
                    margin: "6px 0 0",
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#222",
                  }}
                >
                  {counter.value}
                </h3>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LotStat;
